import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-services-cta-section',
  imports: [RouterLink],
  templateUrl: './services-cta-section.component.html',
  styleUrl: './services-cta-section.component.css',
})
export class ServicesCtaSectionComponent {

}
